export default "__VITE_ASSET__B6FlArr9__"